package com.example.mystybag.sharedmodels.mystyBag.requestModels

import com.example.mystybag.sharedmodels.AllCommands.UPDATE_PROFILE_IMAGE_API
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable
import kotlin.jvm.JvmField

@Serializable
class UpdateProfileImageRequestModel(
    @JvmField
    var profileImageUrl: String = ""
): BaseRequestModel(api = UPDATE_PROFILE_IMAGE_API)